import React, { useState, useEffect } from "react";
import { Page, LayoutSingleColumn } from "../../components";
import TopbarContainer from "../TopbarContainer/TopbarContainer";
import FooterContainer from "../FooterContainer/FooterContainer";
import HeroBanner from "./sections/heroCarousel";
import ProductSearch from "./sections/productSearch";
import ProductSections from "./sections/productSections";
import css from "./productsPage.module.css";

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchParams, setSearchParams] = useState({
    search: "",
    category: "",
    minPrice: "",
    maxPrice: "",
    sortBy: "created",
    sortOrder: "desc"
  });

  useEffect(() => {
    fetchProducts();
  }, [searchParams, currentPage]);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      // Build query parameters
      const params = new URLSearchParams();
      
      if (searchParams.search) params.append('search', searchParams.search);
      if (searchParams.category) params.append('category', searchParams.category);
      if (searchParams.minPrice) params.append('minPrice', searchParams.minPrice);
      if (searchParams.maxPrice) params.append('maxPrice', searchParams.maxPrice);
      if (searchParams.sortBy) params.append('sortBy', searchParams.sortBy);
      if (searchParams.sortOrder) params.append('sortOrder', searchParams.sortOrder);
      if (currentPage) params.append('page', currentPage.toString());
      params.append('limit', '10'); // Show 10 products per page

      const response = await fetch(`${process.env.REACT_APP_INSTAGROOMS_STORE_API_URL}/api/products?${params.toString()}`);
      const data = await response.json();
      
      if (data.status === "success") {
        setProducts(data.data.data || data.data);
        setTotalProducts(data.data.pagination?.totalProducts || 0);
        setTotalPages(data.data.pagination?.totalPages || 0);
      } else {
        console.error('Failed to fetch products:', data.message);
        setProducts([]);
        setTotalProducts(0);
        setTotalPages(0);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      setProducts([]);
      setTotalProducts(0);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchUpdate = (newSearchParams) => {
    setSearchParams(newSearchParams);
    setCurrentPage(1); // Reset to first page when search changes
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <Page title="Products">
        <LayoutSingleColumn
            sideNav={null}
            topbar={<TopbarContainer />}
            currentPage="ProductsPage"
            footer={<FooterContainer />}
        >
            <div className={css.productsPage}>
                <HeroBanner />
                <ProductSearch 
                  searchParams={searchParams}
                  onSearchUpdate={handleSearchUpdate}
                />
                <ProductSections 
                  products={products} 
                  loading={loading}
                  currentPage={currentPage}
                  totalProducts={totalProducts}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
            </div>
        </LayoutSingleColumn>
    </Page>
  );
};

export default ProductsPage;